import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({ root: { marginLeft: theme.spacing(10), marginTop: theme.spacing(4) } }));

const Footer = () => { return <Typography className={useStyles().root} variant="body1">{"Quantum Search "}&copy;{" Ericsson Inc. "}{new Date().getFullYear()}</Typography>; };

export default Footer;
